type SpinnerPropTypes = {
  customClassName?: string
};

const Loader:React.FC<SpinnerPropTypes> = ({ customClassName = '' }) => (
  <div className={`progress-loader ${customClassName}`}>
    <div className="lds-ring">
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
);

export default Loader;
